export default {
	state: {
		dashboard: "0",
		role: [],
		userId: "",
		head: "img/logo.png",
		userName: "",
	},
	mutations: {
		SET_userInfo(state, key) {
			state.dashboard = key.dashboard || "0";
			state.role = key.role || [];
			state.userId = key.userId || "";
			state.head = key.head || "img/head.png";
			state.userName = key.userName || "";
		},
	},
};
